<template>
  <modal
    :title="setModel != undefined ? 'Update OPERATOR' : 'ADD OPERATOR'"
    size="lg"
    @close="$emit('close')"
  >
    <template #content>
      <loadArea v-if="currencies == null"></loadArea>
      <Form
        method="dialog"
        v-slot="{ errors }"
        class="floating-labels p-1rem row"
        ref="form"
        v-if="currencies != null"
      >
        <div class="col-md-6">
          <formGroup
            :title="'Name'"
            v-model="model.Name"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-md-6">
          <formGroup
            :title="'ShortName'"
            v-model="model.ShortName"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-md-4">
          <formGroup
            :title="'MainOperatorId'"
            :as="'select'"
            :disabled="currencies.length == 0"
            v-model="model.MainOperatorId"
            :errors="errors"
            @keydown.enter="save"
          >
            <template #input>
              <option :value="null"></option>
              <option
                v-for="item in operators"
                :value="item.Id"
                :key="item.Id"
                >{{ item.Name }}</option
              >
            </template>
          </formGroup>
        </div>
        <div class="col-md-4">
          <formGroup
            :title="'Logo'"
            v-model="model.Logo"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-md-4">
          <formGroup
            :title="'CurrencyCode'"
            :as="'select'"
            :disabled="currencies.length == 0"
            :buttons="true"
            v-model="model.CurrencyCode"
            :errors="errors"
            @keydown.enter="save"
          >
            <template #input>
              <option :value="null"></option>
              <option
                v-for="item in currencies"
                :value="item.Code"
                :key="item.Code"
                >{{ item.Name }}</option
              >
            </template>
            <template #buttons>
              <button
                type="button"
                @click="addCurrenciesOpen = true"
                class="btn waves-effect waves-light btn-success"
              >
                <i class="fas fa-plus"></i>
              </button>
            </template>
          </formGroup>
        </div>
        <div class="col-md-4">
          <formGroup
            :title="'OutputPort'"
            type="number"
            v-model="model.OutputPort"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-md-4">
          <formGroup
            :title="'IncreementDayCount'"
            type="number"
            v-model="model.IncreementDayCount"
            :rules="{ required: true }"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-md-4">
          <formGroup
            :title="'ResponseItemCount'"
            type="number"
            v-model="model.ResponseItemCount"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-md-4">
          <formGroup
            :title="'MaxHotelCount'"
            type="number"
            v-model="model.MaxHotelCount"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-md-4">
          <formGroup
            :title="'MaxDayCount'"
            type="number"
            v-model="model.MaxDayCount"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-md-4">
          <formGroup
            :title="'ScanModel'"
            type="number"
            v-model="model.ScanModel"
            :rules="{ required: true }"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-auto">
          <formGroup
            :title="'UsingSameHotelsWithMainOperator'"
            as="checkbox"
            v-model="model.UsingSameHotelsWithMainOperator"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-auto">
          <formGroup
            :title="'RegionBased'"
            as="checkbox"
            v-model="model.RegionBased"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-auto">
          <formGroup
            :title="'DurationBased'"
            as="checkbox"
            v-model="model.DurationBased"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-auto">
          <formGroup
            :title="'IsPortal'"
            as="checkbox"
            v-model="model.IsPortal"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-auto">
          <formGroup
            :title="'Active'"
            as="checkbox"
            v-model="model.Active"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
      </Form>
    </template>
    <template #foot>
      <Btn
        class="btn-success btn-md"
        @click="save"
        :disabled="currencies == null"
        :process="process"
        >{{ setModel != undefined ? "Update Operator" : "Add Operator" }}</Btn
      >
    </template>
  </modal>
  <addCurrencies
    v-if="addCurrenciesOpen"
    @close="addCurrenciesOpen = false"
    @add="currencies.push({ Code: $event.Code, Name: $event.Name })"
  ></addCurrencies>
  <addLanguages
    v-if="addLanguagesOpen"
    @close="addLanguagesOpen = false"
    @add="languages.push({ Code: $event.Code, Name: $event.Name })"
  ></addLanguages>
</template>

<script>
import addCurrencies from "@/views/currencies/upsert";
import addLanguages from "@/views/languages/upsert";
export default {
  props: {
    setModel: Object,
    operators: Array,
  },
  components: { addCurrencies, addLanguages },
  data() {
    return {
      addCurrenciesOpen: false,
      model: {
        Active: false,
        CurrencyCode: "",
        DurationBased: false,
        Id: null,
        IncreementDayCount: null,
        IsPortal: false,
        Logo: null,
        MainOperatorId: null,
        MaxDayCount: null,
        MaxHotelCount: null,
        Name: "",
        OutputPort: null,
        RegionBased: false,
        ResponseItemCount: null,
        ScanModel: null,
        ShortName: "",
        UsingSameHotelsWithMainOperator: false,
      },
      currencies: null,
      process: false,
    };
  },
  created() {
    if (this.setModel != undefined) {
      this.model = { ...this.setModel };
    }
    this.$appAxiosAdmin.get(`Currencies`).then((response) => {
      this.currencies = response.data;
    });
  },
  methods: {
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .put(`Operators`, this.model)
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text:
                  this.setModel != undefined
                    ? "The operator has been successfully updated."
                    : "The operator has been successfully added.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              if (this.setModel != undefined) {
                this.$emit("update", response.data);
              } else {
                this.$emit("add", response.data);
              }
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style></style>
